import React from 'react';
import { Link } from 'react-router-dom';
import { Section } from '@/pages/LandingComplete';
import { Button } from '@/components/ui/button';
import { Gift, CheckCircle, ArrowRight } from 'lucide-react';

interface GiftVoucherContent {
  title?: string;
  titleHighlight?: string;
  subtitle?: string;
  features?: string[];
  ctaText?: string;
}

export function DynamicGiftVoucher({ content }: { content: GiftVoucherContent }) {
  const features = content.features || ['Flexibel einlösbar', '12 Monate gültig', 'Beliebiger Wert'];

  return (
    <Section className="relative overflow-hidden">
      {/* Warmer Verlauf im Leiterbahn-Orange des Logos */}
      <div className="absolute inset-0 bg-gradient-to-br from-flame/10 via-background to-flame-soft/10 pointer-events-none" aria-hidden="true"></div>
      <div className="absolute inset-0 bg-circuit opacity-60 pointer-events-none" aria-hidden="true"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-flame/10 border border-flame/25 px-5 py-2 text-flame font-bold mb-6">
          <Gift className="h-5 w-5" />
          Geschenk-Tipp
        </div>

        <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-4">
          {content.title || 'Das perfekte'} <span className="text-primary">{content.titleHighlight || 'Geschenk'}</span>
        </h2>

        <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
          {content.subtitle || 'IT-Hilfe als Gutschein – ideal für Familie und Freunde'}
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {features.map((feature, i) => (
            <div key={i} className="flex items-center gap-2 bg-card rounded-full px-4 py-2 shadow-soft border border-navy/10">
              <CheckCircle className="h-5 w-5 text-emerald-600" />
              <span className="text-foreground/85 font-medium">{feature}</span>
            </div>
          ))}
        </div>

        <Link to="/gutschein">
          <Button className="bg-gradient-flame hover:opacity-95 text-navy-deep px-8 py-6 text-lg font-extrabold rounded-full shadow-soft hover:shadow-lift hover:-translate-y-0.5 transition-all">
            <Gift className="h-5 w-5 mr-2" />
            {content.ctaText || 'Gutschein kaufen'}
            <ArrowRight className="h-5 w-5 ml-2" />
          </Button>
        </Link>
      </div>
    </Section>
  );
}
